import React from "react";
import ReactDOM from "react-dom/client";

import "@fontsource/roboto";
import "./index.css";
import "./styles/style.css";

import App from "./App";
import { Provider } from "react-redux";
import { store } from "./redux";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
